const module = { name: 'test/abTest6254', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


const { EventNames: { AB_TEST_6254_READY } } = eventQueue


import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


const Selectors = {
    CAROUSEL_CTA: '.fd-carousel__buy-tickets',
    CAROUSEL_LINK: '.js-fd-carousel-focus-elem',
    CAROUSEL_POSTER: '.fd-carousel__img',
    DESKTOP_CAROUSEL: '#movie-carousel',
    MOBILE_CAROUSEL: '#now-playing-carousel',
    MOBILE_MOP_ANCHOR: '#mop-info-bloc-wrap',
}


const Classes = {
    TEST_NAME: 'ab-test-6254',
}
function run() {
    debugLog.info(module.name, `listening for Test Event "${AB_TEST_6254_READY}"`);
    eventQueue.on(AB_TEST_6254_READY, (exp) => {
        debugLog.info(module.name, `received "${AB_TEST_6254_READY}"`, exp);
        const expB = exp === 'B';
        const expC = exp === 'C';
        if (expB || expC) {
            document.querySelectorAll(`${isMobile ? Selectors.MOBILE_CAROUSEL : Selectors.DESKTOP_CAROUSEL} ${Selectors.CAROUSEL_LINK}`).forEach((link) => {
                const movieID = link.getAttribute('data-id');
                const movieName = link.getAttribute('aria-label');
                link.classList.add(Classes.TEST_NAME);
                link.querySelector(Selectors.CAROUSEL_POSTER).addEventListener('click', () => {
                    track({
                        event: EventTypes.IN_THEATERS_CAROUSEL_POSTER_CLICK,
                        movieID,
                        movieName,
                    });
                });
                link.querySelector(Selectors.CAROUSEL_CTA).addEventListener('click', () => {
                    track({
                        event: EventTypes.IN_THEATERS_CAROUSEL_CTA_CLICK,
                        movieID,
                        movieName,
                    });
                });
                if (expC && isMobile) {
                    const currentHref = link.getAttribute('href') || '';
                    link.setAttribute('href', currentHref + Selectors.MOBILE_MOP_ANCHOR);
                }
            });
        }
    });
}
module.exports = {
    run,
};
export default module.exports;